import React from 'react';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Config from '~/config';
import IconEdit from '~/components/svg/icon-edit.svg';
import IconEditActive from '~/components/svg/icon-edit-active.svg';
import themeVariables from '~/shared/themeVariables';

const ButtonEditIllust = ({
  onClick,
  t,
  loading,
  role,
  isSelectVectorFile,
}) => {
  const roles = Config.getRoles();

  return (
    <div>
      <button type="button" onClick={onClick} className="button-illust-edit">
        {loading ? (
          <FontAwesomeIcon style={{ width: '1em' }} icon={faSpinner} pulse />
        ) : (
          <>
            {!role || role === roles.GUEST || isSelectVectorFile ? (
              <IconEditActive
                className="icon-edit-active"
                width="20"
                style={{ marginRight: 16 }}
              />
            ) : (
              <IconEdit
                className="icon-edit"
                width="20"
                style={{ marginRight: 16 }}
              />
            )}
          </>
        )}
        {t('edit')}
      </button>
      <style jsx>{`
        .button-illust-edit {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          padding: 8px 16px;
          border-radius: 40px;
          margin-top: 16px;
          width: 192px;
          height: 44px;
          ${!role || role === roles.GUEST || isSelectVectorFile
            ? 'background: #E3E3E3;border:none;color:#ffffff;'
            : 'background: #ffffff;border: 1px solid #7A7A7A;'}
        }
        .button-illust-edit:hover {
          opacity: ${!role || role === roles.GUEST ? '1' : '0.8'};
        }
        @media (max-width: ${themeVariables.breakpoints.mobile.maxWidth}px) {
          .button-illust-edit {
            width: 170px;
            padding: 4px 4px;
          }
        }
      `}</style>
    </div>
  );
};

export default ButtonEditIllust;
